import { Search } from "components/inputs/Search";
import { InfoMessage } from "../InfoMessage";
import { NicheSection } from "../NicheSection";
import { useSearchNiches } from "./useSearchNiches";
import { useChangeOption } from "./useChangeOption";
import { useMediaQuery } from "usehooks-ts";
import { TABLET_WIDTH } from "@/common/utils/device";
import { INicheOption } from "../../popups/AddToNichePopup/types";
import "./NicheSelector.scss";

interface INicheSelector {
  nicheFields: INicheOption[];
  suggestNicheFields: INicheOption[];
  myNichesLoading: boolean;
  gifSuggestedNichesLoading: boolean;
  theme?: "light" | "dark";
  onUpdateNiches: (fields: INicheOption[]) => void;
  onFollowNiche: (niche: INicheOption) => void;
}

export const NicheSelector = ({
  nicheFields,
  suggestNicheFields,
  myNichesLoading,
  gifSuggestedNichesLoading,
  theme = "dark",
  onUpdateNiches,
  onFollowNiche,
}: INicheSelector) => {
  const {
    text,
    handleChange,
    filteredNicheFields,
    filteredSuggestNicheFields,
  } = useSearchNiches({ nicheFields, suggestNicheFields });

  const { handleOptionChange } = useChangeOption({
    nicheFields,
    onUpdateNiches
  });

  const isDesktop = useMediaQuery(`(min-width: ${TABLET_WIDTH}px)`);

  return (
    <div className={`NicheSelector NicheSelector_is${theme}`}>
      <div className="NicheSearch">
        <Search onChange={handleChange} value={text} theme={theme} size={isDesktop ? "m" : "s"} />
        <InfoMessage>You’ll only see Niches you’ve joined that match this content’s tags and preferences.</InfoMessage>
      </div>
      <NicheSection
        text={text}
        title="Niches Available For This Upload"
        isEmpty={!nicheFields.length}
        isLoading={myNichesLoading}
        nicheFields={filteredNicheFields}
        onCheckBoxChange={handleOptionChange}
        onFollowNiche={onFollowNiche}
      />
      <NicheSection
        text={text}
        title="Suggested For You"
        nicheFields={filteredSuggestNicheFields}
        isLoading={gifSuggestedNichesLoading}
        onCheckBoxChange={handleOptionChange}
        onFollowNiche={onFollowNiche}
        isSuggested
      />
    </div>
  );
};
